import { axiosInterceptor } from "../../authInterceptor";
import environment from "../../../../../environments/environment";
import { AxiosError } from "axios";

interface InvoiceTransactionHistory {
  interestPayment: number;
  balance: number;
  isActive: string;
  feePayment: number;
  principalPayment: number;
  postingDate: string;  // ISO Date string
  transactionDate: string;  // ISO Date string
}

interface InvoiceWfApprover {
  id: number;
  approverId: string;
  approverType: string;
}

interface InvoiceStateHistory {
  state: string;
  description: string;
}

interface InvoiceData {
  vendorName: string;
  vendorNumber: string;
  projectNumber: string;
  statusCode: string;
  actionType: string;
  participantId: number;
  description: string;
  invoiceTransactionHistory: InvoiceTransactionHistory[];
  invoiceNumber: string;
  invoiceAmount: number;
  confirmNumber: string;
  dueDate: string;  // ISO Date string
  subsidyAmount: number;
  totalAmount: number;
  processingFee: number;
  paymentMethod: string;
  invoiceWfApprover: InvoiceWfApprover[];
  pmAvailable: number;
  isActive: string;
  clientId: number;
  submittedBy: string;
  freezeInvoice: string;
  fundsDeductionComplete: string;
  invoiceStateHistory: InvoiceStateHistory[];
}


export async function postInvoice(invoiceData: InvoiceData) {
    try {
      const resInvoiceNumberByVendorName = await axiosInterceptor.post(`${environment.postInvoice}`,invoiceData);
      return resInvoiceNumberByVendorName;
    } catch (error: any) {
      if (error instanceof AxiosError) { 
        throw error; 
      }
      throw new Error("Unexpected error occurred");
    }
  }
export async function getProjecInvoiceApprover(clientId: number) {
  try {
    const getProjectInvoieApproverRes = await axiosInterceptor.get(`${environment.getInvoiceApproversURL}?clientId=${clientId}`);
    return getProjectInvoieApproverRes
  } catch (error: any) {
    return error;
  }
}  

export async function postCloneInvoice(invocieId: number, newInvoiceNumber: string ) {
    try {
      const resCloneInvoice = await axiosInterceptor.post(`${environment.postInvoice}${invocieId}/copy/invoice-number/${newInvoiceNumber}`);
      return resCloneInvoice;
    } catch (error: any) {
      if (error instanceof AxiosError) { 
        throw error; 
      }
      throw new Error("Unexpected error occurred");
    }
  }

  export async function deleteProjectInvoice(invocieId: number, clientId: number) {
  try {
    const deletedInvRes = await axiosInterceptor.delete(`${environment.postInvoice}${invocieId}?clientId=${clientId}`);
    return deletedInvRes
  } catch (error: any) {
    return error;
  }
}
